

function createGeometry( width, segments ) {
	
	var geometry = new THREE.PlaneGeometry( width, width, segments, segments );
	
	geometry.applyMatrix(
		new THREE.Matrix4().makeRotationX( Math.PI * 0.5 )
	);
	
	return geometry;
	
}

function createTexture( mesh, scene ) {
	
	var img = new Image();
	var texture = new THREE.Texture( img );
	img.src = 'assets/images/cloud1024.png';
	
	texture.wrapT = THREE.RepeatWrapping;
	texture.wrapS = THREE.RepeatWrapping;
	
	$(img).on('load', function() {
		texture.needsUpdate = true;
		scene.add( mesh );
	});
	
	return texture;
	
}

function updateShader() {
	
}

function createMeshGrid( material, width, gridLength, totalPolygonDensity ) {
	
	var geometry = createGeometry(
		width / gridLength,
		Math.floor( totalPolygonDensity / gridLength )
	);
	
	var meshGrid = new THREE.Object3D();
	
	var mesh;
	var step = width / gridLength;
	
	for( var i=0; i < gridLength; i++ ) {
		for( var j=0; j < gridLength; j++ ) {
			
			mesh = new THREE.Mesh( geometry, material );
			mesh.frustumCulled = false
			
			meshGrid.add( mesh );
			mesh.position.set(
				i * step,
				0,
				j * step
			);
		}
	}
	
	return meshGrid;
}

function updateModuloMeshGrid( cameraPosition, meshes, width, state ) {
	
	var il = meshes.length;
	var halfWidth = width / 2;
	
	return function() {
		var position;
		
		for( var i=0; i < il; i++ ) {
			
			position = meshes[i].position;
	
			position.set(
				( ( position.x - cameraPosition.x + halfWidth ) % width ) + cameraPosition.x - halfWidth,
				position.y,
				( ( position.z - cameraPosition.z + halfWidth ) % width ) + cameraPosition.z - halfWidth
			);
			
		}
		
	};
}

var EndlessTerrain = function( poem, properties ) {
	
	var config = _.extend({
		width				: 4000,
		heightScale			: 200,
		gridLength			: 16,
		totalPolygonDensity	: 1024,
		positionY			: 0,
		height				: 1
	}, properties);
	
	var state = {
		height : config.height
	}
	
	var material = new THREE.ShaderMaterial({
		
		vertexShader    : "#define GLSLIFY 1\n\nuniform sampler2D terrain;\nuniform float heightFactor;\nuniform float width;\n\nvarying float height;\nvarying vec2 vUv;\nvarying float vCameraDistance;\n\nvoid main() {\n\n\tvec4 modelPosition = modelMatrix * vec4(position, 1.0);\n\t\n\tvUv = vec2( modelPosition.x, modelPosition.z ) / width;\n\n\theight = texture2D( terrain, vUv * 0.3 ).w;\n\t\n\tvCameraDistance = distance( modelPosition.xyz, cameraPosition );\n\t\n\t\n\tvec4 modifiedPosition = vec4(\n\t\tposition.x,\n\t\tposition.y + height * width / 20.0 * heightFactor,\n\t\tposition.z,\n\t\t1.0\n\t);\n\t\n\tgl_Position = projectionMatrix * modelViewMatrix * modifiedPosition;\n\t\n}",
		fragmentShader  : "#define GLSLIFY 1\n\nvec3 hsv2rgb_1_0(vec3 c) {\n  vec4 K = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\n  vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n  return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n}\n\n\n\nuniform float width;\nuniform float heightFactor;\n\nvarying float height;\nvarying vec2 vUv;\nvarying float vCameraDistance;\n\nvoid main() {\n\t\n\tfloat hueX = abs(0.5 - fract(vUv.x * 0.8)) * 2.0;\n\tfloat hueY = abs(0.5 - fract(vUv.y * 0.63)) * 2.0;\n\t\n    gl_FragColor = vec4(\n\t\thsv2rgb_1_0(\n\t\t\tvec3(\n\t\t\t\t// mod(xHue, 1.0),\n\t\t\t\t(hueX + hueY) * 0.2 + 0.3,\n\t\t\t\tmix(heightFactor, mix(height, 0.5, 0.8), 0.8),\n\t\t\t\tmix(heightFactor, mix(height, 1.2, 0.35), 0.35)\n\t\t\t)\n\t\t),\n\t\t1.0\n\t);\n\t\n\tfloat fogFactor = smoothstep( 0.0, 1.0, vCameraDistance / width );\n\tvec3 fogColor = vec3( 0.14, 0.14, 0.14 );\n\n\tgl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );\n\t\n}",
		side            : THREE.DoubleSide,
		
		uniforms        : {
			terrain         : { type: 't' },
			heightFactor    : { type: 'f' },
			width           : { type: 'f' },
		},
		attributes      : {}

	})
	
	material.side = THREE.DoubleSide;
	
	var meshGrid = createMeshGrid(
		material,
		config.width,
		config.gridLength,
		config.totalPolygonDensity
	);
	
	meshGrid.position.y = config.positionY;
	
	material.uniforms.terrain.value = createTexture( meshGrid, poem.scene );
	material.uniforms.width.value = config.width / 2;
	material.uniforms.height = state.height
	
	poem.emitter.on( 'update', function() {
		material.uniforms.heightFactor.value = state.height
	})
	
	poem.emitter.on( 'update', updateModuloMeshGrid(
		poem.camera.object.position,
		meshGrid.children,
		config.width,
		state
	));
	
	return state
};

module.exports = EndlessTerrain;